import { Constants } from "../../../contants";
import {
  INITIATE_VIEW_GOHONZON_DATA,
  SET_GOHONZON_OTP,
  SET_GOHONZON_TYPE_FOR_APPLY,
  SET_GOHONZON_VERIFICATION_LIST,
  SET_MEMBERS_FOR_APPLY_GOHONZON,
  SET_MEMBERS_FOR_APPLY_GOHONZON_FAIL,
  SET_MEMBER_FOR_APPLY_GOHONZON,
  SET_RESET_GOHONZON_STATE,
  SET_MEMBER_FOR_TRACKING_GOHONZON,
} from "../../actionTypes/dashboard";

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  error: null,
  applyGohonzonList: [],
  verificationList: [],
  gohonzonType: "OKATAKI_GOHONZON",
  selectedMemberId: null,
  otp: null,
  paginationInfo: {
    currentPage: 0,
    totalPages: 1,
    totalElements: 0,
    pageSize: Constants.DEFAULT_PAGE_SIZE,
  },
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case INITIATE_VIEW_GOHONZON_DATA:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SET_MEMBERS_FOR_APPLY_GOHONZON:
      return {
        ...state,
        applyGohonzonList: payload.data,
        paginationInfo: payload?.paginationInfo ?? INITIAL_STATE.paginationInfo,
        isLoading: false,
      };
    case SET_MEMBERS_FOR_APPLY_GOHONZON_FAIL:
      return {
        ...state,
        applyGohonzonList: [],
        paginationInfo: INITIAL_STATE.paginationInfo,
        isLoading: false,
        error: payload,
      };
    case SET_MEMBER_FOR_APPLY_GOHONZON:
      return {
        ...state,
        selectedMemberId: payload,
      };
    case SET_MEMBER_FOR_TRACKING_GOHONZON:
      return {
        ...state,
        selectedMemberId: payload,
      };
    case SET_GOHONZON_TYPE_FOR_APPLY:
      return {
        ...state,
        gohonzonType: payload,
      };
    case SET_GOHONZON_VERIFICATION_LIST:
      return {
        ...state,
        verificationList: payload.data,
        paginationInfo: payload.paginationInfo,
      };
    case SET_GOHONZON_OTP:
      return {
        ...state,
        otp: payload,
      };
    case SET_RESET_GOHONZON_STATE:
      return {
        ...state,
        applyGohonzonList: [],
        isLoading: true,
      };

    default:
      return state;
  }
};

export default reducer;
